<template>
  <van-dialog
    v-model="visible"
    class="van-clear-style update-app-dialog"
  >
    <div class="card-container">
      <div class="card-title">{{ title }}</div>
      <div class="card-text">{{ content }}</div>
      <button v-if="showConfirmButton" class="update-button" @click="toUpdate">{{ confirmText }}</button>
      <img v-if="showClose" class="close-img" src="~assets/image/icons/close-border-white.png" @click="visible = false" >
    </div>
  </van-dialog>
</template>
<script>
export default {
  data() {
    return {
      title: '檢測到新版本',
      visible: false,
      content: '請先升級到最新版本',
      confirmText: '現在更新',
      showClose: true,
      showConfirmButton: true,
    }
  },
  methods: {
    toUpdate() {
      // setTimeout(() => {
      //   this.$util.nativePie('HIDDEN_RETRY_VIEW')
      // }, 1000)
      this.visible = false
      window.location.href = this.$util.AppDownloadUrl[this.$util.isiOS ? 'iOS' : 'android'].app
    }
  }
}
</script>
<style lang="scss" scoped>
  .update-app-dialog {
    width: 100vw;
    overflow: visible !important;
    /deep/ .van-dialog__content {
      padding: 0;
      overflow: visible;
    }
    /deep/ .van-dialog__footer {
      display: none;
    }
  }
  .card-container {
    width: 534px;
    height: 582px;
    border-radius: 28px;
    margin: 0 auto;
    background: #FFFFFF url('~assets/image/background/update-app.png') no-repeat center top / auto 234px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $color-gray-1;
    position: relative;
    overflow: visible;
    .card-title {
      font-weight: 500;
      font-size: 32px;
      line-height: 44px;
      margin-top: 278px;
    }
    .card-text {
      font-size: 28px;
      line-height: 40px;
      text-align: center;
      width: 446px;
      margin-top: 20px;
    }
    .update-button {
      width: 462px;
      height: 80px;
      border-radius: 40px;
      text-align: center;
      line-height: 80px;
      background: $color-yellow;
      margin-top: 36px;
      font-weight: 500;
      font-size: 28px;
      line-height: 40px;
    }
    .close-img {
      width: 62px;
      position: absolute;
      bottom: -36px;
      left: 50%;
      transform: translate(-50%, 100%);
    }
  }
</style>
